if (!customElements.get("prepme-newsletter-trigger")) {
  // Isolate the visible vendor modal from the cookie app's document key handler.
  // Bubble on body so Klaviyo's own control/tab handlers still run first.
  document.body.addEventListener("keydown", (event) => {
    if (event.key !== "Tab" && event.key !== "Escape") return;
    const dialog = event.target.closest?.('[role="dialog"][aria-modal="true"]');
    if (
      !dialog?.querySelector("form.klaviyo-form") ||
      !dialog.getClientRects().length
    )
      return;
    if (event.key === "Tab") {
      event.stopPropagation();
      return;
    }
    const close = dialog.querySelector("button.klaviyo-close-form");
    if (!close || close.disabled || !close.getClientRects().length) return;
    event.stopPropagation();
    if (event.defaultPrevented) return;
    event.preventDefault();
    if (!event.repeat) close.click();
  });

  customElements.define(
    "prepme-newsletter-trigger",
    class extends HTMLElement {
      constructor() {
        super();
        this.onClick = this.open.bind(this);
        this.onFormEvent = this.handleFormEvent.bind(this);
        this.stopRestore = this.cancelRestore.bind(this);
      }

      connectedCallback() {
        this.button = this.querySelector("button");
        this.status = this.querySelector('[role="status"]');
        this.formId = this.dataset.formId;
        if (
          !this.button ||
          !this.status ||
          !/^[a-zA-Z0-9]{1,64}$/.test(this.formId || "")
        )
          return;
        this.button.disabled = false;
        this.button.addEventListener("click", this.onClick);
        window.addEventListener("klaviyoForms", this.onFormEvent);
      }

      disconnectedCallback() {
        this.button?.removeEventListener("click", this.onClick);
        window.removeEventListener("klaviyoForms", this.onFormEvent);
        this.manualOpen = false;
        this.cancelRestore();
        this.reset();
      }

      cancelRestore() {
        cancelAnimationFrame(this.focusFrame);
        clearTimeout(this.closeTimeout);
        window.removeEventListener("pointerdown", this.stopRestore, true);
        window.removeEventListener("keydown", this.stopRestore, true);
        this.closingDialog = null;
      }

      handleFormEvent(event) {
        const { type, formId } = event.detail || {};
        if (type === "open") {
          this.cancelRestore();
          if (formId !== this.formId) this.manualOpen = false;
        }
        if (type !== "close" || formId !== this.formId || !this.manualOpen)
          return;
        this.manualOpen = false;
        this.reset();
        const dialogs = Array.from(
          document.querySelectorAll('[role="dialog"]'),
        ).filter(
          (dialog) =>
            dialog.querySelector("form.klaviyo-form") &&
            dialog.getClientRects().length,
        );
        if (dialogs.length !== 1) return;
        const [dialog] = dialogs;
        this.cancelRestore();
        this.closingDialog = dialog;
        window.addEventListener("pointerdown", this.stopRestore, true);
        window.addEventListener("keydown", this.stopRestore, true);
        this.closeTimeout = setTimeout(this.stopRestore, 2000);
        const waitForClose = () => {
          if (this.closingDialog !== dialog || !this.isConnected) return;
          if (dialog.isConnected && dialog.getClientRects().length) {
            this.focusFrame = requestAnimationFrame(waitForClose);
            return;
          }
          this.focusFrame = requestAnimationFrame(() => {
            this.cancelRestore();
            if (this.isConnected) this.button.focus({ preventScroll: true });
          });
        };
        this.focusFrame = requestAnimationFrame(waitForClose);
      }

      reset() {
        clearTimeout(this.timer);
        if (this.pending && Array.isArray(window._klOnsite)) {
          const index = window._klOnsite.indexOf(this.pending);
          if (index !== -1) window._klOnsite.splice(index, 1);
        }
        this.pending = null;
        this.button?.removeAttribute("aria-busy");
      }

      open() {
        if (this.pending) return;
        this.cancelRestore();
        this.manualOpen = true;
        this.status.hidden = true;
        this.button.setAttribute("aria-busy", "true");
        const command = ["openForm", this.formId, () => finish(false)];
        const finish = (failed) => {
          if (this.pending !== command) return;
          this.reset();
          if (failed) this.manualOpen = false;
          this.status.hidden = !failed;
        };
        this.pending = command;
        this.timer = setTimeout(() => finish(true), 8000);
        try {
          window._klOnsite = window._klOnsite || [];
          window._klOnsite.push(command);
        } catch {
          finish(true);
        }
      }
    },
  );
}
